module.exports = __webpack_public_path__ + "img/Reacondicionarte.8c4d15b0.png";